<template>
	<div class="operation_box">
		<div class="operation_item">
			<el-dropdown
				split-button type="primary"
				@click="primaryAction.command"
				@command="(command) => command()"
			>
				<i :class="primaryAction.icon"></i>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="(item, index) in actionList"
									  :key="index"
									  :command="item.command"
									  :disabled="item.disabled"
					>
						<i :class="item.icon"></i>
						{{ item.text }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>
<script>
import {enumDef} from "@/common/enumDefs";

export default {
	methods: {
		clickEdit(showPdf = false) {
			let { data, editFun } = this.params;

			// If there is an invoice document already assigned, always show it even if not requested
			if (data.invoiceDocument) {
				showPdf = true;
			}

			editFun(data, showPdf);
		},
		clickDelete() {
			let { data, delFun } = this.params;
			delFun(data);
		},
		clickSubmit() {
			let { data, subFun } = this.params;
			subFun(data);
		},
		clickConvert() {
			let { data, convertFun } = this.params;
			convertFun(data);
		},
		clickWithdraw() {
			let { data, withdrawFun } = this.params;
			withdrawFun(data);
		},
	},
	computed: {
		actionList() {
			return [
				{
					command: () => this.clickEdit(false),
					disabled: false,
					icon: this.editable ? "fa fa-pencil" : "fa fa-search-plus",
					text: this.editable ? this.$t("common.edit") : this.$t("common.details"),
					isPrimary: true
				},
				{
					command: () => this.clickEdit(true),
					disabled: this.disableUploadDocument,
					icon: "fa fa-file-pdf-o",
					text: this.$t("common.upload.document"),
				},
				{
					command: this.clickSubmit,
					disabled: !this.submittable,
					icon: "fa fa-paper-plane",
					text: this.$t("common.button.toReview"),
				},
				{
					command: this.clickConvert,
					disabled: !this.convertible,
					icon: "fa fa-link",
					text: this.$t("seller.marketSounding.button.convert"),
				},
				{
					command: this.clickWithdraw,
					disabled: !this.withdrawable,
					icon: "fa fa-undo",
					text: this.$t("seller.marketSounding.button.withdraw"),
				},
				{
					command: this.clickDelete,
					disabled: !this.deletable,
					icon: "fa fa-trash-o",
					text: this.$t("common.delete"),
				},
			];
		},
		primaryAction() {
			return this.actionList.find(action => action.isPrimary);
		},
		submittable() {
			let { data } = this.params;
			return !!data.invoiceNumber && enumDef.upcomingOpportunityStatus.isDraft(data.opportunityStatus);
		},
		editable() {
			let { data } = this.params;
			return enumDef.upcomingOpportunityStatus.isDraft(data.opportunityStatus);
		},
		deletable() {
			let { data } = this.params;
			return data.opportunityStatus === enumDef.upcomingOpportunityStatus.New;
		},
		disableUploadDocument() {
			return !this.editable || this.params.data.invoiceDocumentFileId;
		},
		convertible() {
			let { data } = this.params;
			return data.receivableStatus === enumDef.receivableStatus.ProspectiveConfirmed;
		},
		withdrawable() {
			let { data } = this.params;
			let isProspective = enumDef.receivableStatus.isProspective(data.receivableStatus);
			let isExpiredBecauseOfDueDate = data.receivableStatus === enumDef.receivableStatus.UnsoldFinished;
			let isOpportunityDraft = enumDef.upcomingOpportunityStatus.isDraft(data.opportunityStatus);
			let wasAlreadyConverted = data.opportunityConverted;

			return (isProspective || isExpiredBecauseOfDueDate) && !isOpportunityDraft && !wasAlreadyConverted;
		}
	}
};
</script>
